import styled from '@emotion/styled'
import * as SSC from '../Shared.styles'

export const NoResultsCard = styled(SSC.Card)({
  alignItems: 'center',
  justifyContent: 'center',
  height: '400px',

  img: {
    width: '200px'
  }
})
